<template>
  <div class="box-container">
    <loading-component v-if="!datatype || datatype.isLoading"> </loading-component>
    <error-component v-else-if="datatype && datatype.errorMessage" :text="datatype.errorMessage" align="center" justify="center" class="row-header ma-0 pa-0">
    </error-component>
    <v-row v-else class="ma-0 pa-0 row-header" justify="center" align="center" :class="IF.MyFontTitle">
      <div class="box-container-horizontal">
        <v-row class="row-header ma-0 pa-0" justify="center" align="center">
          <v-tooltip :disabled="hideTooltips" location="right">
            <template v-slot:activator="{ props }">
              <v-icon
                v-if="stations.length > 1 && !isOnMobile"
                id="sortIcon"
                v-bind="props"
                :class="isOnMobile ? 'ma-1 pa-0' : 'ma-2 pa-0'"
                :size="IF.MyIconSize"
                variant="outlined"
                style="cursor: pointer"
                >mdi-sort</v-icon
              >
              <v-menu activator="#sortIcon">
                <v-list class="ma-0 pa-0" width="200">
                  <v-list-item
                    v-for="sort in devsSortTypes"
                    :key="sort.id"
                    style="cursor: pointer"
                    :style="sort.name == devsSortType ? 'background-color: ' + Colors.MenuColor : ''"
                    :density="IF.Density"
                  >
                    <v-list-item-title class="ma-0 pa-0" :class="IF.MyFont" @click="devsSortType = sort.name">{{ sort.name }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <span>{{ "Сортиране: " + devsSortType }}</span>
          </v-tooltip>

          <v-tooltip :disabled="hideTooltips" location="right">
            <template v-slot:activator="{ props }">
              <t-btn v-if="stations.length > 1" id="filterStations" :class="isOnMobile ? 'ma-1 pa-0 px-1' : ''" v-bind="props">
                <span>
                  {{ devsFilterType }}
                </span>
              </t-btn>
              <v-menu activator="#filterStations">
                <v-list class="ma-0 pa-0" width="160">
                  <v-list-item
                    v-for="ff in devsFilterTypes"
                    :key="ff.name"
                    style="cursor: pointer"
                    :style="ff.name == devsFilterType ? 'background-color: ' + Colors.MenuColor : ''"
                    :density="IF.Density"
                  >
                    <v-list-item-title class="ma-0 pa-0" :class="IF.MyFont" @click="devsFilterType = ff.name">{{ ff.name }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <!-- <v-select
                class="myselect"
                v-bind="props"
                v-model="devsFilterType"
                :items="devsFilterTypes"
                item-title="name"
                item-value="name"
                hide-details
                single-line
                :density="IF.Density"
              > 
              <template slot.append>
                  <v-icon v-if="stations.length > 1" id="sortIcon" v-bind="props" class="ma-2 pa-0" :size="IF.MyIconSize" variant="outlined" style="cursor: pointer"
                >mdi-magnify-scan</v-icon
              >
            </template> 
              </v-select>-->
            </template>
            <span>{{ "Филтриране по: " + devsFilterType }}</span>
          </v-tooltip>
        </v-row>

        <v-row class="ma-0 pa-0 row-content" justify="center" align="center">
          <v-icon class="ma-1 pa-0" :size="IF.MyIconSize" :color="Colors.IconColor" @click="devsFilterType = 'Online'">mdi-ev-station</v-icon>
          <v-card-title class="pl-0 pr-2" :class="IF.MyFontTitle" @click="devsFilterType = 'Online'" style="cursor: pointer">
            {{ (isOnMobile ? "" : "Online: ") + getOnlineCount }}
          </v-card-title>
          <template v-if="getChargingCount">
            <v-icon class="ma-1 pa-0" color="green" :size="IF.MyIconSize" @click="devsFilterType = 'Активни'">mdi-car-electric-outline</v-icon>
            <v-card-title class="pl-0 pr-2" :class="IF.MyFontTitle" @click="devsFilterType = 'Активни'" style="cursor: pointer">
              {{ (isOnMobile ? "" : "Активни: ") + getChargingCount.toFixed(0) }}
            </v-card-title>
          </template>
          <!-- <template v-if="getCurrentChargeRate > 0 && getStations.length > 1">
            <v-icon class="my-1 pa-0" color="green" :size="IF.MyIconSize">mdi-flash</v-icon>
            <v-card-title class="pl-0 pr-2" :class="IF.MyFontTitle">
              {{ isOnMobile ? getCurrentChargeRate.toFixed(3) : "Натоварване: " + getCurrentChargeRate.toFixed(3) + " KWh" }}
            </v-card-title>
          </template> -->
          <template v-if="getOfflineConnectorsCount">
            <v-icon class="ma-1 pa-0" color="red" :size="IF.MyIconSize">mdi-ev-plug-ccs2</v-icon>
            <v-card-title class="pl-0 pr-2" :class="IF.MyFontTitle">
              {{ (isOnMobile ? "" : "Дефектирал конектор: ") + getOfflineConnectorsCount }}
            </v-card-title>
          </template>
          <template v-if="!!getDailySum && IF.ShowSums">
            <v-icon class="ma-1 pa-0" color="green" :size="IF.MyIconSize">mdi-account-cash-outline</v-icon>
            <v-card-title class="pl-0 pr-2" :class="IF.MyFontTitle">
              {{ (isOnMobile ? "" : "За деня: ") + getDailySum.toFixed(2) + " лв." }}
            </v-card-title>
          </template>
        </v-row>
      </div>
    </v-row>

    <v-divider></v-divider>
    <v-row class="ma-0 pa-0 row-content text-center" align-content="start" justify="center">
      <charge-station-card
        v-for="(s, ixx) in getStations"
        :station="s"
        :key="ixx"
        :imageClick="() => openSettings(s)"
        class="ma-2"
        :elevation="3"
        :width="360"
        :height="220"
      >
      </charge-station-card>
    </v-row>
  </div>
</template>

<script>
// import HTTPSender from "@/js/HTTPSender";
import ChargeStationConnectorStatus from "@/js/ChargeStationConnectorStatus";
import ChargeStationStatus from "@/js/ChargeStationStatus";
import HTTPSender from "@/js/HTTPSender";
import DataManager from "@/data/DataManager";
import { g_Events } from "@/main";
// import { g_Dialog } from "@/main";

export default {
  components: {},
  name: "ChargingStations",
  data: () => ({
    datatype: null,
    datatypeChartMonthly: null,
    tabs: {},
    stations: [],
    devsSortTypes: [
      { id: 0, name: "Текущо активни", prop: "CurrentlyActive", proptype: Number },
      { id: 1, name: "Мощност ↓", prop: "Power", proptype: Number, asc: true },
      { id: 2, name: "Мощност ↑", prop: "Power", proptype: Number },
      { id: 3, name: "Оборот ↓", prop: "SumToday", proptype: Number, asc: true },
      { id: 4, name: "Оборот ↑", prop: "SumToday", proptype: Number },
      { id: 5, name: "Име ↓", prop: "name", proptype: String, asc: true },
      { id: 6, name: "Име ↑", prop: "name", proptype: String },
      { id: 7, name: "Статус ↓", prop: "Status", proptype: Number, asc: true },
      { id: 8, name: "Статус ↑", prop: "Status", proptype: Number },
      { id: 9, name: "УБ ↓", prop: "fd.sn", proptype: String, asc: true },
      { id: 10, name: "УБ ↑", prop: "fd.sn", proptype: String },
    ],

    devsSortType: "Текущо активни",
    devsFilterTypes: [
      { name: "Всички", prop: "" },
      { name: "Активни", prop: "CurrentlyActive", value: (p) => p >= 1 },
      { name: "Online", prop: "Status", value: (s) => s == ChargeStationStatus.Online },
      { name: "Offline", prop: "Status", value: (s) => s == ChargeStationStatus.Offline },
      { name: "DC", prop: "PowerType", value: (p) => p == "DC" },
      { name: "AC", prop: "PowerType", value: (p) => p == "AC" },
    ],
    devsFilterType: "Online",
    ChargeStationConnectorStatus: ChargeStationConnectorStatus,
  }),
  computed: {
    getStations() {
      if (!this.datatype || this.datatype.isLoading) {
        return [];
      } else {
        var f = this.devsFilterTypes.find((f) => f.name == this.devsFilterType);
        var data = this.stations.filter((s) => !f.prop || f.value(s[f.prop]));
        var sort = this.devsSortTypes.find((st) => st.name == this.devsSortType);
        switch (sort.proptype) {
          case String:
            return data.sort((a, b) => {
              var pp1 = Object.byString(a, sort.prop);
              var pp2 = Object.byString(b, sort.prop);
              if (pp1 === null || pp1 === undefined) return sort.asc ? 1 : -1;
              if (pp2 === null || pp2 === undefined) return sort.asc ? -1 : 1;
              var res = pp1.localeCompare(pp2, "bg", { sensitivity: "base" });
              return sort.asc ? res : -res;
            });
          case Number:
          case Boolean:
          default:
            return data.sort((a, b) => {
              var p1 = Object.byString(a, sort.prop);
              var p2 = Object.byString(b, sort.prop);
              if (p1 === null || p1 === undefined) return sort.asc ? 1 : -1;
              if (p2 === null || p2 === undefined) return sort.asc ? -1 : 1;
              return (p1 - p2) * (sort.asc ? 1 : -1);
            });
        }
      }
    },
    getOnlineCount() {
      var online = this.stations.filter((s) => s.Status == ChargeStationStatus.Online).length;
      var offline = this.stations.filter((s) => s.Status == ChargeStationStatus.Offline).length;
      return online + "/" + (online + offline);
    },
    getOfflineConnectorsCount() {
      var connectors = Object.values([].concat(...this.stations.map((s) => [...Object.values(s.onlineConnectors)])));
      var defect = connectors.filter((c) => c.statusNotifReqStr == ChargeStationConnectorStatus.Faulted).length;
      return defect;
    },
    getChargingCount() {
      var connectors = Object.values([].concat(...this.stations.filter((s) => s.IsOnline).map((s) => [...Object.values(s.onlineConnectors)])));
      var charges = connectors.filter((c) => c.statusNotifReqStr == ChargeStationConnectorStatus.Charging).length;
      return charges;
    },
    getDailySum() {
      return this.stations.map((s) => s.SumToday).sum();
    },
    getCurrentChargeRate() {
      return this.stations.map((s) => s.ChargeRateKW).sum();
    },
  },
  methods: {
    setMeta(meta, err) {
      this.datatype = meta.datatype;
      if (err.success && !err.message) {
        this.datatype.isLoading = false;
        this.stations = this.datatype.data ?? [];
      } else {
        this.datatype.errorMessage = err.message;
        this.datatype.isLoading = false;
      }
    },
    openSettings(s) {
      // this.$router.push({ name: "Control", params: { currentStation: s } });
      this.$router.push({ path: "/Control", query: { id: s.id } });
    },
    calcOfflineMinutes(dateForDiff) {
      var diffMs = new Date() - dateForDiff;
      var mins = Math.round(diffMs / 60000);
      var m = mins % 60;
      var h = (mins - m) / 60;
      if (h > 0) {
        return h + " ч. " + m + " мин.";
      }
      return m + " мин.";
    },
    SPAM() {
      HTTPSender.SendGETreq("Command/UnlockConnector/A11224917765/1")
        .done(() => {
          console.log("spam done");
          setTimeout(() => {
            this.SPAM();
          }, 50);
        })
        .fail(() => {
          console.log("fail");
          setTimeout(() => {
            this.SPAM();
          }, 50);
        });
    },
  },
  created() {
    if (this.$route.query && this.$route.query.filter) {
      this.devsFilterType = this.$route.query.filter;
    }
  },
  mounted() {
    this.bus.on(g_Events.ChargeStationRefresh, () => {
      this.stations = DataManager.getData(DataManager.data.ChargeStation, true);
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    });
    // this.SPAM();
  },
};
</script>

<style lang="scss">
.charging {
  height: 100px;
  color: green;
  -webkit-animation-name: greenBlink;
  -o-animation-name: greenBlink;
  -moz-animation-name: greenBlink;
  animation-name: greenBlink;

  -webkit-animation-iteration-count: infinite;
  -o-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  animation-iteration-count: infinite;

  -webkit-animation-duration: 2s;
  -o-animation-duration: 2s;
  -moz-animation-duration: 2s;
  animation-duration: 2s;
}

@-webkit-keyframes greenBlink {
  0% {
    color: green;
  }
  50% {
    color: rgb(19, 185, 19);
  }
  51% {
    color: green;
  }
  100% {
    color: rgb(19, 185, 19);
  }
}

@-moz-keyframes greenBlink {
  0% {
    color: green;
  }
  50% {
    color: rgb(19, 185, 19);
  }
  51% {
    color: green;
  }
  100% {
    color: rgb(19, 185, 19);
  }
}
@-moz-keyframes greenBlink {
  0% {
    color: green;
  }
  50% {
    color: rgb(19, 185, 19);
  }
  51% {
    color: green;
  }
  100% {
    color: rgb(19, 185, 19);
  }
}

@keyframes greenBlink {
  0% {
    color: green;
  }
  50% {
    color: rgb(19, 185, 19);
  }
  51% {
    color: green;
  }
  100% {
    color: rgb(19, 185, 19);
  }
}
</style>

<style scoped>
</style>
